export default __webpack_public_path__ + "static/media/cancer.cacfe8a6.svg";